module.exports = __webpack_public_path__ + "media/images/email-6d0a037d031edfb389616c0db668e95d.png";